import vueResource from "vue-resource";
import Vue from "vue"
import ServiceUtils from './ServiceUtils'
import ServiceDialog from "./ServiceDialog";
import ServiceLog from "./ServiceLog";
import loding from "../components/loading/index"
import axios from 'axios'

Vue.use(vueResource);
let parserRes = function(res) {
  if (res.resultNumber === 0 || res.resultNumber === '0') {
    if (res.resultObject) {
      return res.resultObject;
    } else {
      return true;
    }
  } else {
    ServiceDialog.showAlert('温馨提示',res.resultMsg);
    ServiceLog.print("parserRes：处理数据的时候","处理数据的时候");
    return false;
  }
};

export default{
  testLogin(callback){
    let URL =ServiceUtils.config.domain+ "/weixin/vipmanage/"+ServiceUtils.config.sellerId+"/login.html?openerid=oszA2t9wQljXHoylYtRhzT2MCTHg";
    Vue.http.get(URL).then((res)=>{
      if(callback){
        callback();
      }
    });
  },


    /**
     * 获取商户外卖配置
     */
    getSellerTakeoutConfig:(callback)=>{
        let url = "{0}/weixin/takeoutsetup/storeinfo.html?sellerid={1}&storeid={2}";
        url = url.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId);
        Vue.http.get(url).then((res)=>{
            let b =parserRes(res.data);
            callback(b);
        },(err)=>{ })
    },


    /**
     * 利用高德地图获取骑行距离
     */
    calculateDistanceByGdMap:(origin,destination,callback) =>{
        var url = "https://restapi.amap.com/v4/direction/bicycling?origin={0},{1}&destination={2},{3}&key=083e1f1ae47870abdd45da70f08a06f7";
        url = url.format(origin.lng,origin.lat,destination.lng,destination.lat);
        Vue.http.get(url).then((res)=>{
            console.log("Distance Res:",res);
            try{
                if(res.body && res.body.data.paths){
                   let path = res.body.data.paths[0];
                   if(callback){ callback(path.distance,path.duration); }
                }else{
                  callback(-1);
                }
            }catch(e){
                if(callback){ callback(-1); }
            }
        },(err)=>{ if(callback){ callback(-1); } })
    },

    /**
     * 根据距离获取配送费
     * @param distance
     * @param callback
     */
    calculateDeliveryCharge:(distance,callback)=>{
        let url = "{0}/weixin/onlineorder/{1}/{2}/calcharge.html?distance={3}";
        url = url.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId,distance);
        Vue.http.get(url).then((res)=>{
            let b =parserRes(res.data);
            if(b && callback) callback(b.charge);
        },(err)=>{ })
    },

  /**
   * 1、获取当前地理位置
   * @param finish
   * @param error
   */
  getLocation:(finish,error)=> {
    loding.show({ text:'正在加载地理位置',borderWidth:5});
    let geolocation = new BMap.Geolocation();
    let _isTimeout = true;
    geolocation.getCurrentPosition(function(r) {
      loding.hide();
      _isTimeout = false;
      if (this.getStatus() === BMAP_STATUS_SUCCESS) {
        ServiceUtils.config.longitude = r.point.lng;
        ServiceUtils.config.latitude  = r.point.lat;
        finish();
      } else {
        if(error){
          error("获取地理位置失败:" + this.getStatus());
        }
      }
    }, {
      enableHighAccuracy: true
    });
    setTimeout(()=>{
      if(_isTimeout){
        error();
        loding.hide();
      }
    },10000);
  },

  getStroeNmae(callback){
    let url="{0}/weixin/wxmenusetup/v2/store.html?sellerid={1}&storeid={2}"
      .format(ServiceUtils.config.domain, ServiceUtils.config.sellerId, ServiceUtils.config.storeId);
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        let b =parserRes(res.data);
        if(callback){
          callback(b)
        }
      })
    }else {

    }
  },


  /**
   * 2、获取所有门店数据
   * @param finish
   */
  getStoreData:(finish)=>{
    let url  = "{0}/weixin/onlineorder/{1}/stores.html".format(ServiceUtils.config.domain,ServiceUtils.config.sellerId);
    loding.show({ text:'获取所有门店数据',borderWidth:5});
    ServiceLog.print('获取所有门店数据：',url);

    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        let b =parserRes(res.body);
        if(finish){
          finish(b)
        }
      })
    }else {
      url = 'static/test-data/store.json';
      setTimeout(()=>{
        Vue.http.get(url).then((res)=>{
          loding.hide();
          let b =parserRes(res.body);
          if(finish){
            finish(b)
          }
        })
      },1000);
    }
  },
  /**
   * 2.获取用户行为
   */
  useraction:(url)=>{
    Vue.http.get(ServiceUtils.config.domain+url);
  },

  /**
   * 3、获取背景图片
   * @param callback
   */
  getBgPic:(callback)=>{
    if(ServiceUtils.getBgPicData){ //如果有数据就从缓存中取数据
      callback(ServiceUtils.getBgPicData)
      return;
    }
    loding.show({ text:'获取主页图片',borderWidth:5});
    let url  = '{0}/weixin/wxmenusetup/v2/indexpage.html?sellerid={1}&storeid={2}&menuclass={3}'.
    format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId,ServiceUtils.config.menuClass);
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        if (res.body.resultNumber == 0) {
          if(callback && res.body.resultObject){
            console.log(res.body.resultObject)
            callback(res.body.resultObject)
            ServiceUtils.getBgPicData = res.body.resultObject;
          }
        }
      })
    }else {
      url = 'static/test-data/store.json';
      setTimeout(()=>{
        Vue.http.get(url).then((res)=>{
          loding.hide();
          let b =parserRes(res.body);
          if(callback){
            callback(b)
          }
        })
      },1000);
    }
  },
  /**
   * 4.获取图片数据
   * @param callback
   * @param schemaMenu
   */
  getPicData:(schemaMenu,callback)=>{
    //loding.show({ text:'获取图片数据',borderWidth:5});
    if(ServiceUtils.picData.length>0){
      loding.hide();
      callback();
      return ;
    }
    var version = Math.ceil(((new Date().valueOf())/(1000*60))) ;

    //普通菜谱
    var loadNormalMenu = function () {
      let url = ServiceUtils.getCdnDomain()+"/weixin/document/{0}/menus/release/{1}/{2}/hots.json?v={3}";
      url = url.format(ServiceUtils.config.sellerId, ServiceUtils.config.storeId, ServiceUtils.config.menuClass, version);
      Vue.http.get(url).then((res)=>{
        loding.hide();
        if(res.body){
          ServiceUtils.picData = res.body.data;
          callback();
        }
      },()=>{
        loding.hide();
      })
    };

    //加载时效菜
    var loadSchemaMenu = function () {
      let url = ServiceUtils.config.domain+"/weixin/document/{0}/menus/release/{1}/{2}/schemahots.json?v={3}";
      let v = parseInt(new Date().getTime()/1000);
      url = url.format(ServiceUtils.config.sellerId, ServiceUtils.config.storeId, ServiceUtils.config.menuClass, v);
      Vue.http.get(url).then((res)=>{
        loding.hide();
        if(res.body){
          ServiceUtils.picData = res.body.data;
          callback();
        }
      },()=>{
        loding.hide();
        loadNormalMenu();
      })
    };

    if(!ServiceUtils.config.test){
      if(schemaMenu){//获取时效菜谱
        loadSchemaMenu();
      }else{//获取正常菜谱
        loadNormalMenu();
      }
    }else {
      var  url = 'static/test-data/hots.json?v=12';
      Vue.http.get(url).then((res)=>{
        loding.hide();
        if(res.body){
          ServiceUtils.picData.length = 0;
          ServiceUtils.picData = res.body.data;
          callback();
        }
      },()=>{
        loding.hide();
        ServiceDialog.showAlert('温馨提示','获取图片数据网络错误')
      })
    }
  },


  /**
   * 5、获取原始菜单数据
   * @param callback
   */
  getOriginMenuData: (callback) => {
    // loding.show({ text:'获取菜单数据',borderWidth:5});
      let url = '{0}/weixin/wxmenusetup/v2/originmenu.html?sellerid={1}&storeid={2}'.format(ServiceUtils.config.domain, ServiceUtils.config.sellerId, ServiceUtils.config.storeId);
      if (ServiceUtils.menuData.length > 0) { //从缓存中获取菜单数据
          ServiceLog.print("从缓存中加载菜单数据...");
          loding.hide();
          if (callback) {
              callback();
          }
          return;
      }

    Vue.http.get(url).then((res) => {
          loding.hide();
          if (res.body) {
              let b = parserRes(res.body);
              ServiceUtils.createMenuData(b.menuData, b.suiteData);
              callback();
          }
      }, () => {
          loding.hide();
          ServiceDialog.showAlert('温馨提示', '获取图片数据网络错误')
      })
  },

  /**
   * 获取可点菜数据
   * @param callback
   */
  getMenufilter:(callback)=>{
    // ServiceUtils.config.tableNo = 'S2'
    let url = `${ServiceUtils.config.domain}/weixin/onlineorder/${ServiceUtils.config.sellerId}/${ServiceUtils.config.storeId}/menufilter.html?tableno=${ServiceUtils.config.tableNo}`;
    if (ServiceUtils.menufilterData.length > 0) { //从缓存中获取菜单数据
      ServiceLog.print("从缓存中加载菜单数据...");
      loding.hide();
      if (callback) {
        callback();
      }
      return;
    }
    Vue.http.get(url).then((res) => {
      loding.hide();
      if (res.body) {
        let b = parserRes(res.body);
        ServiceUtils.menufilterData = b.menuCodes;
        callback();
      }
    }, () => {
      loding.hide();
      ServiceDialog.showAlert('温馨提示', '获取可点菜数据错误')
    })
  },

  /**
   * 5、获取配菜数据
   * @param callback
   */
  getSideDish:(callback)=>{
    //loding.show({ text:'获取配菜数据',borderWidth:5});
    var version = Math.ceil(((new Date().valueOf())/(1000*60)));
    let  url = "{0}/weixin/document/{1}/menus/release/{2}/{3}/peicaidata.json?v={4}".
    format(ServiceUtils.getCdnDomain(), ServiceUtils.config.sellerId,
      ServiceUtils.config.storeId, ServiceUtils.config.menuClass,version) ;
    if(Array.isArray(ServiceUtils.sideDish)&&ServiceUtils.sideDish.length>0){ //从缓存中获取配菜数据
      loding.hide();
      if(callback){
        callback();
      }
      return ;
    }
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        res.body.menudata.forEach((v) =>{
            ServiceUtils.sideDish.append(v.menuitem);
        });
        if(callback){
          callback();
        }
      },(err)=>{
        loding.hide();
        if(callback){
          callback();
        }
      })
    }else {
      url = 'static/test-data/sidedish.json?v=12';
      Vue.http.get(url).then((res)=>{
        loding.hide();
        res.body.menudata.forEach((v) =>{
          if(v.isGroup=='0'){
            ServiceUtils.sideDish.append(v.menuitem);
          }
        });
        if(callback){
          callback();
        }
      },(err)=>{
        loding.hide();
        if(callback){
          callback();
        }
      })
    }
  },
  /**
   * 获取沽清数据
   * @param callback
   */
  getSaleOutData:(callback)=>{
    let url = "{0}/weixin/onlineorder/{1}/{2}/saleout.html".format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId);
    //loding.show({ text:'获取沽清数据',borderWidth:5});

    if(ServiceUtils.saleout.length>0){
      loding.hide();
      if(callback){
        callback()
      }
      return ;
    }
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        let b =parserRes(res.body);
        if(b && callback){
          ServiceUtils.saleout.length = 0;
          ServiceUtils.saleout.append(b.saleout);
          callback()
        }
      },(err)=>{
        loding.hide();
        callback();
      })
    }else {
      url = 'static/test-data/saleout.json?v=12';
      Vue.http.get(url).then((res)=>{
        loding.hide();
        let b =parserRes(res.body);
        if(b && callback){
          ServiceUtils.saleout.length = 0;
          ServiceUtils.saleout.append(b.saleout);
          callback()
        }

      },(err)=>{
        loding.hide();
        callback();
      })
    }

  },
  /**
   * 获取推荐菜状态
   * @param callback
   */
  getRecommendAtionSatate(callback){
    if(ServiceUtils.RecommendAtionState){
      callback(ServiceUtils.RecommendAtionState);
      return;
    }
    let url = "{0}/weixin/wxmenusetup/v2/recommendationstate.html?sellerid={1}&storeid={2}&menuclass={3}"
      .format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId,ServiceUtils.config.menuClass);
    loding.show({ text:'获取推荐菜状态',borderWidth:5});

    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=> {
        loding.hide();
        ServiceLog.print("获取推荐菜品状态res:", res.body);
        let b = parserRes(res.body);
        ServiceUtils.RecommendAtionState = b;
        if(callback&&b){
          callback(b);
        }
      },(err)=>{
          loding.hide();
      });
    }else {
      let url = "static/test-data/getRecommendState.json?v=17";
      Vue.http.get(url).then((res)=> {
        ServiceLog.print("获取推荐菜品状态res:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      });
    }
  },
  /**
   * 获取推荐菜
   * @param callback
   */
  getRecommendMenu(callback){
    let url = "{0}/weixin/document/{1}/menus/release/{2}/{3}/recommend.json?V={4}"
      .format(ServiceUtils.config.domain,ServiceUtils.config.sellerId, ServiceUtils.config.storeId,ServiceUtils.config.menuClass,
        Math.floor(new Date().valueOf()/(1000*60)));
    loding.show({ text:'获取推荐菜',borderWidth:5});

    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=> {
        loding.hide();
        ServiceLog.print("获取推荐菜:", res.body);
        if(callback){
          callback(res.body);
        }
      },(err)=>{
          loding.hide();
      });
    }else {
      let url = "static/test-data/getRecommendState.json?v=17";
      Vue.http.get(url).then((res)=> {
        ServiceLog.print("获取推荐菜:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      });
    }
  },
  /**
   * 下单
   * @param bd
   * @param callback
   */
  sendBill(billHead,bd,callback) {
    loding.show({ text:'正在下单',borderWidth:5});
    let url = '{0}/weixin/onlineorder/{1}/order.html';
    url = url.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId) ;
    var requestMap= {
      storefrontid: ServiceUtils.config.storeId,
      orderType: billHead.orderType+"",
      orderNum: billHead.qty,
      orderAmount:Math.round(billHead.amount*100 * 100) / 100,
      orderDetail:bd,
      tableNo:billHead.tableNo,
      memo:billHead.memo,
      distance:billHead.distance,
      orderScene:billHead.orderScene||0
    };
    if(!ServiceUtils.config.test){
      Vue.http.post(url,requestMap).then((res)=>{
        loding.hide();
        if(res.body.resultNumber == -1){
          ServiceDialog.showAlert("提示",res.body.resultMsg);
        }
        ServiceUtils.delAllCacheData();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      },(err)=>{})
    }else {
      let url = "static/test-data/send-response.json?v=17";
      Vue.http.get(url).then((res)=> {
        ServiceLog.print("下单:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      });
    }
  },

    /**
     * 获取未支付的点单数据
     */
    getUnPayOrder() {
        ServiceUtils.getCacheData();
        if((ServiceUtils.suitBillData.length+ServiceUtils.noSuitBillData.length)>0){//本地有缓层
          return;
        }
        let scene = 0;
        if(ServiceUtils.config.menuClass==0){
          scene = 0;//大厅堂食
        }else if(ServiceUtils.config.menuClass==1){
          scene = 2;//外卖
        }

        let url = '{0}/weixin/onlineorder/{1}/unpay.html?storeid={2}&scene={3}';
        url = url.format(ServiceUtils.config.domain, ServiceUtils.config.sellerId,ServiceUtils.config.storeId,scene);
        axios.get(url).then(response => {
            let res = parserRes(response.data);
            if (res) {
                if (res.length > 0) {//服务器端有缓层数据
                    ServiceUtils.noSuitBillData.length = 0;
                    ServiceUtils.suitBillData.length = 0;
                    res.forEach(item => {
                        if (item.isGroup == 0) {
                            ServiceUtils.noSuitBillData.push(item);
                        } else if (item.isGroup == 1) {
                            ServiceUtils.suitBillData.append(item.menuItem)
                        }
                    });
                    ServiceUtils.calculateCarTotal();
                    ServiceUtils.calculateTypeNum();
                }
            }
        }).catch(error => {
        });
    },

    deleteBill(callback) {
        loding.show({ text:'正在清除已点菜数据!',borderWidth:5});
        let scene = 0;
        if (ServiceUtils.config.menuClass == 0) {
            scene = 0;//大厅堂食
        } else if (ServiceUtils.config.menuClass == 1) {
            scene = 2;//外卖
        }
        let url = '{0}/weixin/onlineorder/{1}/unpay.html?storeid={2}&scene={3}';
        url = url.format(ServiceUtils.config.domain, ServiceUtils.config.sellerId, ServiceUtils.config.storeId, scene);
        axios.delete(url).then(response => {
            loding.hide();
            let res = parserRes(response.data);
            if (res && callback) {
                ServiceUtils.delAllCacheData();
                callback();
            }
        }).catch(error => {
            loding.hide();
        });
    },


  /**
   * 检查餐桌是否存在
   * @param callback
   */
  checkTable(callback){
    loding.show({ text:'检查餐桌是否存在',borderWidth:5});
    let url = "{0}/weixin/onlineorder/{1}/{2}/checktable.html?tableno={3}"
      .format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId,ServiceUtils.config.tableNo);
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        let b = res.body;
        if(b.resultNumber == 0){
          callback();
        }else {
          ServiceDialog.showAlert('温馨提示',b.resultMsg)
        }
      },(err)=>{loding.hide();})
    }else {
      let url = "static/test-data/response.json?v=17";
      Vue.http.get(url).then((res)=> {
        ServiceLog.print("检查餐桌是否存在:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      });
    }
  },
  /**
   * 获取已支付订单
   * @param callback
   */
  getBill(callback){
    loding.show({ text:'获取已支付订单',borderWidth:5});
    let url = "{0}/weixin/onlineorder/{1}/order.html?storeid={2}"
      .format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,ServiceUtils.config.storeId);
    if(!ServiceUtils.config.test){
      Vue.http.get(url).then((res)=>{
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      },(err)=>{loding.hide();})
    }else {
      let url = "static/test-data/myBill.json?v=17";
      Vue.http.get(url).then((res)=> {
        ServiceLog.print("检查餐桌是否存在:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        if(callback&&b){
          callback(b);
        }
      });
    }
  },


    /**
   * 加载提货二维码
   * @param outtradeno
   * @param callback
   */
  getQrcode(outtradeno,callback) {
    loding.show({text: '获取提货二维码', borderWidth: 5});
    let request = {
      requestMap: {
        outtradeno: outtradeno,
        methodname: 'getQrcode4Online',
        sellerid: ServiceUtils.config.sellerId,
      }
    };
    let url = "{0}/weixin/onlineorder/{1}/deliveryqrcode.html?outtradeno={2}"
      .format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,outtradeno);
    if (!ServiceUtils.config.test) {
      Vue.http.get(url).then((res) => {
        loding.hide();
        let b = parserRes(res.body);
        console.log(b);
        if (callback && b) {
          callback(b.picBase64);
        }
      }, (err) => {
        loding.hide();
      })
    } else {
      let url = "static/test-data/qrcode.json?v=17";
      Vue.http.get(url).then((res) => {
        ServiceLog.print("检查餐桌是否存在:", res.body);
        loding.hide();
        let b = parserRes(res.body);
        console.log(b);
        if (callback && b) {
          callback(b.picBase64);

        }
      });
    }
  },

  /**
   * 获取预点菜
   * @param callback
   */
  getPreFood(callback){
    loding.show({text: '正在加载预点菜', borderWidth: 5});
    if(!ServiceUtils.config.test){
      let url="{0}/weixin/onlineorder/{1}/preorder.html".format(ServiceUtils.config.domain, ServiceUtils.config.sellerId);
      Vue.http.get(url).then((res)=> {
        loding.hide();
        ServiceLog.print("获取预点菜res:", res.body);
        if(res.body.resultNumber==0){
          if(callback){
            callback(res.body.resultObject);
          }
        }
      }, ()=> {
        loding.hide();
        ServiceDialog.showAlert('温馨提示', '获取预点菜网络错误');
      });
    }else {
      let url = "static/test-data/sendbill";
      loding.hide();
      setTimeout(() => {
        Vue.http.get(url).then( (res)=> {
          loding.hide();
          ServiceLog.print("T获取预点菜res:", res.body);
          if(res.body.resultNumber==0){
            if(callback){
              callback(res.body.resultObject);
            }
          }
        }, ()=> {
          loding.hide();
          ServiceDialog.showAlert('温馨提示', '获取预点菜网络错误');
        });
      },1000);
    }
  },

  /**
   * 清除预点菜
   * @param callback
   */
  delPreFood(callback){
    if(!ServiceUtils.config.test){
      let url="{0}/weixin/onlineorder/{1}/preorder.html".format(ServiceUtils.config.domain, ServiceUtils.config.sellerId);
      Vue.http.delete(url).then((res) => {
        if(res.body.resultNumber==0){
          if(callback){
            callback(res.body.resultObject);
          }
        }
      },  ()=> {
        ServiceDialog.showAlert('温馨提示', '清除预点菜网络错误');
      });
    }else {
      var url = "static/test-data/response.json?v=17";
      setTimeout(() => {
        Vue.http.get(url).then( (res) =>{
          ServiceDialog.hideLoading();
          ServiceLog.print("T获取预点菜res:", res.body);
          if(res.body.resultNumber==0){
            if(callback){
              callback(res.body.resultObject);
            }
          }
        },  ()=> {
          ServiceDialog.hideLoading();
          ServiceDialog.showAlert('温馨提示', '清除预点菜网络错误');
        });
      },3000);
    }
  },

  /**
   * 获取用户配送信息
   * @param callback
   * http://ip:port/weixin/takeout/{sellerid}/shippinginfo.html
   */
  getUserTakeoutInfo(callback){
    let URL = "{0}/weixin/takeout/{1}/shippinginfo.html";
    URL = URL.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId);
    axios.get(URL).then(response=>{
      let res = parserRes(response.data);
      if(res){
        callback(res);
      }
    }).catch(error=>{ });
  },

  /**
   * 添加用户信息
   * @param callback
   * @param postData
   */
  addUserTakeoutInfo(postData, callback) {
      let URL = "{0}/weixin/takeout/{1}/shippinginfo.html";
      URL = URL.format(ServiceUtils.config.domain, ServiceUtils.config.sellerId);
      axios.post(URL, postData).then(response => {
          let res = parserRes(response.data);
          if (res) {
              callback(true);
          }
      }).catch(error => {
      });
  },

  /**
   *删除用户配送信息
   * @param callback
   * @param postData
   * http://ip:port/weixin/takeout/{sellerid}/ordershippinginfo.html
   */
  deleteUserTakeoutInfo(postData, callback) {
      let URL = "{0}/weixin/takeout/{1}/shippinginfo.html";
      URL = URL.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId);
      axios.delete(URL, postData).then(response => {
          let res = parserRes(response.data);
          if (res) {
              callback(res);
          }
      }).catch(error => {
      });
  },

  /**
   * 添加订单配送信息
   */
  addOrderShippingInfo(postData,callback){
    var URL = "{0}/weixin/takeout/{1}/ordershippinginfo.html";
    URL = URL.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId);
    axios.post(URL,postData).then(response=>{
        let res = parserRes(response.data);
        if(res && callback){
          callback(res);
        }
    }).catch(err=>{})
  },
    /**
     * 通知服务器更新骑手配送信息
      * @param dispatchid
     * @param callback
     */
  notifyServerUpdateQSDeliveryInfo(dispatchid,callback){
        var URL = "{0}/weixin/takeoutdelivery/{1}/dispatchdtl.html";
        URL = URL.format(ServiceUtils.config.domain,dispatchid);
        axios.put(URL).then(response=>{
            let res = parserRes(response.data);
            if(res && callback){
                callback(res);
            }
        }).catch(err=>{})
  },
    /**
     * 刷新骑手配送信息
      * @param dispatchid
     * @param callback
     */
  refreshQSDeliveryInfo(dispatchid,callback){
        var URL = "{0}/weixin/takeoutdelivery/{1}/dispatchdtl.html";
        URL = URL.format(ServiceUtils.config.domain,dispatchid);
        axios.get(URL).then(response=>{
            let res = parserRes(response.data);
            if(res && callback){
                callback(res);
            }
        }).catch(err=>{})
  },

    /**
     * 获取必点菜
      */
    getBidianMenu(callback) {
      let URL = "{0}/weixin/wxmenusetup/v2/bidian.html?sellerid={1}&storeid={2}&menuclass={3}"
      URL = URL.format(ServiceUtils.config.domain, ServiceUtils.config.sellerId, ServiceUtils.config.storeId, ServiceUtils.config.menuClass);
      axios.get(URL).then(resp=>{
          let res = parserRes(resp.data);
          if(res && callback){
              callback(res);
          }
      })
    },

  /**
   * 根据点菜订单号查询支付剩余金额
   */
  GetLastAmount(data,callback) {
    let URL = "{0}/YumstonePay/OnlineOrder/GetLastAmount.html"
    data.sellerid = ServiceUtils.config.sellerId;
    URL = URL.format(ServiceUtils.config.domain);
    axios.post(URL,data).then(resp=>{
      let res = parserRes(resp.data);
      if(res && callback){
        callback(res);
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/service/ServiceHttp.js